export default {
    setUserCommentPost(state, userCommentPosts) {
        const groupedByPostId = userCommentPosts.reduce((acc, user) => {
            if (!acc[user.post_id]) {
                acc[user.post_id] = [];
            }
            acc[user.post_id].push(user);
            return acc;
        }, {});
        state.userCommentPost = groupedByPostId;
    },
    setCommentCountPost(state, commentCountPosts) {
        for (let postId in commentCountPosts) {
            state.commentCountPost[commentCountPosts[postId].post_id] = { comments: commentCountPosts[postId].comment_count };
        }
    },
    cacheUserCommentPost(state, userCommentPost) {
        if (state.userCommentPost[userCommentPost.post_id]) {
            state.userCommentPost[userCommentPost.post_id].unshift(userCommentPost);
        } else {
            state.userCommentPost[userCommentPost.post_id] = [userCommentPost];
        }
    },
    cacheCommentCountPost(state, commentCountPost) {
        if (state.commentCountPost[commentCountPost.post_id]) {
            state.commentCountPost[commentCountPost.post_id].comments++;
        } else {
            state.commentCountPost[commentCountPost.post_id] = { comments: commentCountPost.comment_count };
        }
    }
};